import { atom } from 'jotai'

import { SemesterInfo } from '../features/gateway/pages/DataBoard/types'

export const semesterInfoAtom = atom<SemesterInfo | undefined>(undefined)
